<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
    >
      <template v-slot:activator="{ on }">
              <v-btn v-on="on" text icon>
             <v-badge
        color="green"

      >
        <template v-slot:badge>
          <span v-if="messagesCount > 0">{{ messagesCount }}</span>
        </template>
        <v-icon large>mail</v-icon>
      </v-badge>
            </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Message Center</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <center class='mt-5'
          v-if="messages.length === 0">
          <span>No messages</span>
        </center>
 <v-list-item-group color="primary">
        <v-list :key='index' v-for='(message,index) in messages'>
          <v-list-item two-line dense @click.stop='initMessageModal(message)'>
            <v-list-item-action>
              <v-icon v-if='message.read === false'>mail</v-icon>
              <v-icon v-else>drafts</v-icon>

            </v-list-item-action>

      <v-list-item-content>

          <v-list-item-title>{{message.title}}</v-list-item-title>
            <v-list-item-subtitle>{{message.createdAt}}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

        </v-list>
 </v-list-item-group>
      </v-card>
    </v-menu>
     <v-dialog
      v-model="dialog"
      max-width='500'
    >
      <v-card v-if='currentMessage'>
        <v-card-title class="headline">{{currentMessage.title}}</v-card-title>

        <v-card-text>
          {{currentMessage.messageBody}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import { updateLastRead} from '../../helper/firestore'
import { mapFields } from 'vuex-map-fields';
  export default {
    data: () => ({
      currentMessage : null,
      fav: true,
      menu: false,
      message: false,
      hints: true,
      dialog : false,
    }),
     computed: {
      ...mapFields([
        'isAuthorized',
        'user',
        'messages',
        'messagesCount',
        'snackBarshow',
        'snackBarType',
        'snackBarmessage',
        'overlay',
        'isPublic'
      ]),
    },
    methods : {
      initMessageModal(item){
        //mark message as read
        item.read = true
        this.messagesCount = this.messages.filter(message => {return message.read === false}).length
        //send post req to end point to mark message as read
        updateLastRead(item, () => {
        })
        this.currentMessage=item
        this.dialog = true
      }
    }
  }
</script>
